import {
    Panel, Avatar, TextArea, Button,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

const ReconComment = ({
    initials, comments, setComments, createComment, setToastMessage,
    commentData, createIsLoading, showAllCommentsBtn, setShowAllCommentsBtn,
    itemsToShow, setItemsToShow,
}) => {
    const maxCommentsToShow = 3;
    return (
        <Panel
            style={{ marginTop: '1.5rem', paddingBottom: '2rem', maxHeight: '50rem' }}
            title="COMMENTS"
            className="a-increase-child-color-level-by-1 comment-section"
        >
            <Row style={{ marginTop: '1rem', padding: 0 }}>
                <Col md={1} style={{ padding: 0 }}>
                    <div className="true-comply-data-recon-result__avatar"><Avatar label={initials} size="middle" /></div>
                </Col>
                <Col style={{ padding: '0 1rem 0 0' }}>
                    <div className="a-h6" style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>POST YOUR COMMENT HERE</div>
                    <TextArea
                        placeholder="Type here"
                        className="fix-textarea"
                        value={comments}
                        onChange={e => setComments(e)}
                        textBoxSize="lg"
                    />
                    <div className="true-comply-data-recon-result_post_btn">
                        <Button
                            size="lg"
                            onClick={async () => {
                                if (comments.trim().length > 0) {
                                    await createComment().then(() => setToastMessage('Comment is saved.'));
                                    commentData.refetch();
                                    setComments('');
                                }
                            }}
                            isLoading={createIsLoading}
                        >
                            POST
                        </Button>
                    </div>
                </Col>
            </Row>
            {commentData?.data ? commentData.data.getReconUserComments.slice(0, itemsToShow).map((comment, id) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={id}>
                    <Row style={{ marginTop: '1rem', padding: 0 }}>
                        <Col md={1} style={{ padding: 0 }}>
                            <div className="true-comply-data-recon-result__avatar"><Avatar label={comment.initials} size="middle" /></div>
                        </Col>
                        <Col style={{ padding: '0 1rem 0 0' }}>
                            <span
                                className="a-h6"
                                style={{ marginTop: '0.5rem' }}
                            >
                                {`${comment.firstName} ${comment.lastName}`}
                            </span>
                            <span
                                style={{ marginLeft: '1rem', color: 'gray' }}
                            >
                                {moment(comment.createdAt).format('MMM-DD HH:mm A')}
                            </span>
                            <div>
                                {comment.commentText}
                            </div>
                        </Col>
                    </Row>
                    <hr />
                </div>
            )) : <span />}
            {(showAllCommentsBtn && commentData?.data?.getReconUserComments.length > maxCommentsToShow)
                ? (
                    <div
                        className="a-h6 true-comply-data-recon-result_show_All_comments"
                        onClick={
                            () => {
                                setItemsToShow(commentData.data && commentData.data.getReconUserComments.length);
                                setShowAllCommentsBtn(false);
                            }
                        }
                        role="presentation"
                    >
                        VIEW ALL COMMENTS
                    </div>
                )
                : <div />}
        </Panel>
    );
};

export default ReconComment;
